const w = window;
const $ = jQuery;

import './vendor/jquery.easing.1.3.js'
import './plugins/pagescroll.js'
import './plugins/googlemap.js'
import mapstyle from './json/mapstyle.json'

import './page/top'
import './page/product'

w.gmap_load = ()=> $(w).trigger('map_ready');
$('html').removeClass('no-js')

$(()=>{

/****************************
 * menu toggle
 */
  const $menu_btn = $('[data-plugin=menutoggle]');
  if($menu_btn.length) $('body').append( $('<div />',{class:'c-overlay'}) );
  $menu_btn.on('click',function(){
    $('body').toggleClass( $(this).data('toggle-class') )
  });


/****************************
 * 新規ウインドウ
 */
  $('[data-plugin=openwindow]').on('click',function(e){
    e.preventDefault();
    var $this = $(this),
        data = $this.data(),
        size = 'width='+(data.width||600)+', height='+(data.height||500)+',';
    w.open(this.href,(data.title||'share this site'),size+"menubar=no, toolbar=no, scrollbars=yes");
  });



/****************************
 * ソース読み込みスクリプト
 */
  $('[data-load-html]').each(function(){
    const $this = $(this),
          filepath = $this.data('load-html');
    $.get(`/assets/source/${filepath}.html`).done((html)=>{
      $this.replaceWith(html);
    });
  });


/****************************
 * ブロックリンク作成
 */
  if( $('[data-href]').length ){
    $('[data-href]').each(function(){
      const href = $(this).data('href');
      const $link = $('<a />',{href:href});
      $(this).wrapInner($link);
    });
  }

/****************************
 * 郵便番号検索ボタン
 */
  $('[data-plugin=ajaxzip]').on('click',()=>{
    AjaxZip3.zip2addr('zip','','addr','addr'); // eslint-disable-line no-undef
    return false;
  });

});

/****************************
 * ページロードアクション
 */
$(w).on('load',()=>{
  $('body').removeClass('is-loading');
});

/****************************
 * googlemap
 */
$(w).on('map_ready',()=>{
  $(function(){
    const $gmap = $('[data-plugin=googlemap]');
    $gmap.googlemap({styleObj:{ name:'mapstyle', style:mapstyle} });
  });
});




